export default __webpack_public_path__ + "static/5-9d3f0a2617578e502beeb0340d70b052.png";